var React = require('react');

function LogoAngular (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.92859 4.27012L3.14841 14.8249L9.901 18.5714V11.6076H7.52779L6.41144 14.4001L4.33447 14.4382L9.901 2.05536V1.42859L1.92859 4.27012ZM9.901 6.06133L8.26078 9.9543H9.901V6.06133ZM9.90309 9.9543V6.05636L9.91734 6.02255L11.8004 9.9543H9.90309ZM9.90309 11.6076H12.5182L13.7402 14.4371H15.6657L9.90318 2.0505L9.90309 2.0507V1.42863L18.089 4.22006L16.7646 14.7726L9.90309 18.5693V11.6076Z","fill":"currentColor"}));
}

LogoAngular.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = LogoAngular;

LogoAngular.default = LogoAngular;
